import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  buildPayload,
  GraphqlRequestType,
  ItemNotFound,
} from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { SolutionModel } from '@app/src/app/modules/solution/classes/default/model/solution.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class SolutionByRequestQuery extends AbstractGraphqlRequest<
  SolutionModel | ItemNotFound
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findOneSolutionBy($payload: SolutionRequestPayloadInput) {
        findOneSolutionBy(payload: $payload) {
          id
          category {
            id
            title
            description
            slug
          }
          cover {
            id
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          picture {
            id
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          slug
          title
          description
          shortDescription
          active
          createdAt
          updatedAt
          deletedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let item = data.findOneSolutionBy;

    if (item) {
      return new SolutionModel(item);
    }

    return new ItemNotFound();
  }
}
